import React from "react";
import { useLocation, Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  const routeNameMap = {
    procurement: "Procurement & POs",
    receiving: "Receiving & GRN",
    inventory: "Inventory Catalog",
    warehouse: "Warehouses & Bins",
    "stock-transfer": "Stock Transfer",
    sales: "Sales & POS",
    customers: "Customers & Accounts",
    suppliers: "Suppliers & Vendors",
    finance: "Finance & Ledger",
    employees: "Employees & Payroll",
    "batch-expiry": "Batch & Expiry Watch",
    "dead-stock": "Dead Stock & Reorder",
    returns: "Returns & Damages",
    analytics: "Reports & Analytics",
    notifications: "Alerts & Tasks",
    "audit-log": "Audit Trail",
    "access-control": "Role & Access Matrix",
    settings: "Settings"
  };

  return (
    <nav className="flex items-center gap-1.5 text-xs text-slate-500 dark:text-slate-400 py-3">
      <Link
        to="/"
        className="flex items-center gap-1 text-slate-600 dark:text-slate-300 hover:text-emerald-600 transition font-medium"
      >
        <Home className="w-3.5 h-3.5" />
        <span>Home</span>
      </Link>
      {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;
        const name = routeNameMap[value] || value.replace(/-/g, " ");

        return (
          <React.Fragment key={to}>
            <ChevronRight className="w-3 h-3 text-slate-400" />
            {isLast ? (
              <span className="font-semibold text-slate-900 dark:text-white capitalize">
                {name}
              </span>
            ) : (
              <Link
                to={to}
                className="hover:text-emerald-600 dark:hover:text-emerald-400 transition capitalize"
              >
                {name}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
